import Grid from "@aura-design/system/grid"
import { PrismicNextImage } from "@prismicio/next"
import { isFilled, asText, asDate } from "@prismicio/client"
import { PrismicRichText } from "@prismicio/react"

interface EventsByDayProps {
  events: any
}

export const EventsByDay = ({ events }: EventsByDayProps) => {
  const groupEventsByDay = (events: any) => {
    const map = new Map()

    events.forEach((event: any) => {
      const eventDate = asDate(event.data.date)
      if (!eventDate) return

      const key = eventDate.toLocaleString("es-CO").split(",")[0]
      if (!map.has(key)) {
        map.set(key, {
          day: eventDate.toLocaleDateString("es-CO", { weekday: "long" }),
          fullDate: eventDate.toLocaleDateString("es-CO", {
            day: "numeric",
            month: "long",
          }),
          date: eventDate,
          events: [],
        })
      }

      map.get(key).events.push(event)
    })

    return Array.from(map.values()).sort((a, b) => a.date - b.date)
  }

  const grouped = groupEventsByDay(events.data.results)

  return (
    <div className="space-y-6 md:space-y-12 px-1 md:px-2">
      {grouped.map((group) => (
        <div key={group.date.toISOString()} className="md:grid md:grid-cols-12 md:gap-4">
          <div className="flex justify-start gap-1 items-center mb-1 md:block md:col-span-3 md:mb-0">
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold capitalize my-0">{group.day}</h2>
            <p className="text-base md:text-base lg:text-lg">{group.fullDate}</p>
          </div>
          <div className="space-y-6 border-solid border-x-0 border-b-0 border-[#1c2b44] pt-2 md:col-span-9 md:border-r-0 md:border-y-0 md:border-r-0 md:border-l-2 md:pl-3">
            {group.events.map((event: any) => (
              <CollectionEvent doc={event} key={event.id} />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

interface CollectionEventProps {
  data: {
    date: string | null
    title: any
    description: any
  }
}

const CollectionEvent = ({ doc, ...props }: { doc: CollectionEventProps }) => {
  const date = asDate(doc.data.date)

  const formattedTime = date.toLocaleTimeString("es-CO", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })

  return (
    <div {...props} className="mb-3">
      <div className="flex items-start justify-between">
        <h3 className="font-bold text-sm relative mb-0">
          {isFilled.richText(doc.data.title) && asText(doc.data.title)}
        </h3>
        <div className="text-sm font-bold text-right whitespace-nowrap grow border-solid border-x-0 border-t-0 border-accents-3 ">
          Hora: {formattedTime}
        </div>
      </div>

      {isFilled.richText(doc.data.description) && (
        <div className="text-base leading-relaxed">
          <PrismicRichText field={doc.data.description} />
        </div>
      )}
    </div>
  )
}
